import { FC, useCallback, useMemo, useRef, useState } from 'react';
import { ImageResizeMode, ImageSourcePropType } from 'react-native'
import styled from 'styled-components/native'
import { layout } from 'styled-system'
import { useBreakPointProps } from '../../utils/utils'
import { Box } from '../Box'
import { SkeletonPlaceHolder } from '../SkeletonPlaceHolder'

const StyledImage = styled.Image`
  ${layout}
` as any

export interface ImageProps {
  source: string | any
  resizeMode?: ImageResizeMode | Array<ImageResizeMode>
  width: string | number | Array<string | number>
  height: string | number | Array<string | number>
  fallbackImage?: number
  onError?: () => void
  borderRadius?: number
}

interface modifiedImageinterface {
  source: {
    uri?: string
  }
}

export const Image: FC<ImageProps> = (props) => {
  const modifiedProps = useBreakPointProps<ImageProps>(props)
  const timerRef = useRef<any>()
  const { source: propSource, onError, fallbackImage, ...restProps } = modifiedProps
  const [loading, setLoading] = useState(typeof propSource !== 'string')
  // TODO:
  const defaultImageUrl = ''
  const modifiedPropSource = propSource?.default ? propSource?.default : propSource
  const source: ImageSourcePropType | modifiedImageinterface | any = useMemo(
    () =>
      typeof modifiedPropSource !== 'string'
        ? modifiedPropSource
        : {
            uri: modifiedPropSource?.length === 0 ? defaultImageUrl : modifiedPropSource,
          },
    [modifiedPropSource],
  )
  const isRemoteUrl = source?.uri?.includes('http') ?? false
  const defaultOnError = useCallback(() => {
    setLoading(false)
    if (onError) {
      onError()
    }
  }, [onError])

  const onLoadStart = useCallback(() => {
    if (isRemoteUrl) {
      timerRef.current = setTimeout(() => {
        setLoading(true)
      }, 200)
    }
  }, [isRemoteUrl])

  const onLoadEnd = useCallback(() => {
    if (isRemoteUrl) {
      clearTimeout(timerRef?.current)
    }
    setLoading(false)
  }, [isRemoteUrl])
  return (
    <Box {...restProps}>
      <StyledImage
        source={source}
        defaultSource={fallbackImage}
        onLoadStart={onLoadStart}
        onLoadEnd={onLoadEnd}
        onError={defaultOnError}
        {...restProps}
      />
      {isRemoteUrl && (
        <Box position="absolute" bg="TRANSPARENT">
          <SkeletonPlaceHolder hide={!loading}>
            <Box {...restProps} />
          </SkeletonPlaceHolder>
        </Box>
      )}
    </Box>
  )
}
